<template>
  <donut-chart
    v-if="donutData.length"
    :id="`donut${chartId}`"
    class="donut-chart"
    :data="donutData"
    :colors="colors"
    resize="true"
    :formatter="valueFormatter"
  ></donut-chart>
</template>

<script>
import Raphael from "raphael/raphael";
global.Raphael = Raphael;
import { DonutChart } from "vue-morris";
import "imports-loader?jQuery=jquery,this=>window!webpack-raphael/raphael";
import "imports-loader?jQuery=jquery,this=>window!govpredict-morris/morris";

export default {
  name: "AgingDonutChart",
  components: {
    DonutChart
  },
  props: {
    donutData: Array,
    colors: Array,
    chartId: Number
  },
  data() {
    return {};
  },
  methods: {
  valueFormatter: function(value) {
    if(this.chartId !== 1){
      return value;
    } else{
      let formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumSignificantDigits: 10
      });
      let formatedValue = formatter.format(value);
      return formatedValue;
    }
  }
  },
  mounted() {
    // console.log(this.donutData, this.colors, this.chartId);
  }
};
</script>

<style>
.donut-chart{
  height: 200px;
}
</style>